export default [
    {
        path: '/customer/list',
        name: 'customer_list',
        component: () => import('@src/customer/customer-data/customer-list'),
        meta: {
            title: 'Kunden',
            role: 'ROLE_LIST_CUSTOMER',
        },
    },
    {
        path: '/customer/create',
        name: 'customer_create',
        component: () => import('@src/customer/customer-data/customer-create'),
        meta: {
            title: 'Neuen Kunden anlegen',
            role: 'ROLE_EDIT_CUSTOMER',
        },
    },
    {
        path: '/customer/edit/:customerNumber',
        name: 'customer_edit',
        component: () => import('@src/customer/customer-data/customer-edit'),
        props(route) {
            return { ...route.params };
        },
        meta: {
            title: 'Kunde bearbeiten',
            role: 'ROLE_EDIT_CUSTOMER',
        },
    },
    {
        path: '/customer-group/list',
        name: 'customer_group_list',
        component: () => import('@src/customer/customer-group/customer-group-list'),
        meta: {
            title: 'Kundengruppen',
            role: 'ROLE_LIST_CUSTOMER_GROUP',
        },
    },
    {
        path: '/customer-group/create',
        name: 'customer_group_create',
        component: () => import('@src/customer/customer-group/customer-group-edit'),
        meta: {
            title: 'Kundengruppe erstellen',
            role: 'ROLE_EDIT_CUSTOMER_GROUP',
        },
    },
    {
        path: '/customer-group/edit/:id',
        name: 'customer_group_edit',
        component: () => import('@src/customer/customer-group/customer-group-edit'),
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        meta: {
            title: 'Kundengruppe bearbeiten',
            role: 'ROLE_EDIT_CUSTOMER_GROUP',
        },
    },
];
